export default "__VITE_ASSET__DcjKWTj6__"